import React from 'react';
import Header from '../directives/header';
import { Container, Row, Col, Button, Card, Form } from 'react-bootstrap';
import Footer from '../directives/footer';
import '../css/launchprocess.css';

const PrivacyPolicy = () => {
  return (
    <>
      <Header />
      <div className="subheader">
        <Container>
          <Row>
            <Col lg={12}>
              <h2>Privacy Policy</h2>
            </Col>
          </Row>
        </Container>
      </div>
      <section className="launchprocess pt-5">
        <Container className="position-relative">
          <Row className="align-items-center">
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">1. Introduction</h4>
              </div>
              <p>
                Unitronix Corp. ("Unitronix," "we," "us," or "our") respects
                your privacy. This Privacy Policy explains how we collect, use,
                and protect your{' '}
                <b className="text-white fw-normal">personal information </b>{' '}
                when you use our Website{' '}
                <a
                  href="https://www.unitronix.ai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.unitronix.ai
                </a>
              </p>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  2. Information We Collect
                </h4>
              </div>
              <p>We collect the following types of information:</p>
              <div className="mb-4">
                <h6>a) Information You Provide</h6>
                <ul>
                  <li className="mb-2">
                    Name, email, phone number, and any details you provide when
                    signing up for updates or services.
                  </li>
                  <li className="mb-2">
                    Any personal data submitted through{' '}
                    <b className="text-white fw-normal">
                      contact forms or email inquiries.{' '}
                    </b>
                    .
                  </li>
                </ul>
              </div>
              <div>
                <h6>b) Automatically Collected Information</h6>
                <ul>
                  <li className="mb-2">
                    <b className="text-white fw-normal">
                      IP addresses, browser type, device information,{' '}
                    </b>{' '}
                    and <b className="text-white">website activity logs.</b>.
                  </li>
                  <li>
                    Cookies and tracking technologies for site analytics (you
                    can disable cookies in your browser settings).
                  </li>
                </ul>
              </div>
              <div>
                <h6>c) Third-Party Data</h6>
                <ul>
                  <li className="mb-2">
                    • If you connect your account with third-party platforms
                    (such as exchanges or financial institutions), we may
                    collect transaction data and other relevant information.
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  3. How We Use Your Information
                </h4>
              </div>
              <p>We use collected data to:</p>
              <div>
                <ul>
                  <li className="mb-2">Provide and improve our services.</li>
                  <li className="mb-2">
                    Process transactions and secure accounts.
                  </li>
                  <li className="mb-2">Prevent fraud and security risks.</li>
                  <li className="mb-2">
                    Send updates, newsletters, or promotional offers (with your
                    consent).
                  </li>
                </ul>
              </div>
            </Col>

            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  4. How We Protect Your Data
                </h4>
              </div>
              <p>
                We implement industry-standard{' '}
                <b className="text-white">encryption, security protocols,</b>{' '}
                and access controls to protect your personal data. However, we
                cannot <b className="text-white">guarantee 100% security</b>{' '}
                against cyber threats.
              </p>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  5. Data Sharing & Third-Party Services
                </h4>
              </div>
              <div>
                <ul>
                  <li className="mb-2">
                    We{' '}
                    <b className="text-white">
                      do not sell or rent your personal data.
                    </b>
                  </li>
                  <li className="mb-2">
                    We may share limited information with{' '}
                    <b className="text-white">trusted service providers</b> who
                    assist in our operations (e.g., analytics, cloud hosting).
                  </li>
                  <li className="mb-2">
                    We may disclose data if{' '}
                    <b className="text-white">
                      required by law, regulations, or government requests.
                    </b>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  6. User Rights & Choices
                </h4>
              </div>
              <div>
                <ul>
                  <li className="mb-2">
                    <b className="text-white">Access & Correction:</b> You can
                    request to view or edit your personal data.
                  </li>
                  <li className="mb-2">
                    <b className="text-white">Opt-Out:</b> You can unsubscribe
                    from emails at any time.
                  </li>
                  <li className="mb-2">
                    <b className="text-white">Data Deletion:</b> You may request
                    data deletion, subject to legal requirements.
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  7. Cookies & Tracking Technologies
                </h4>
              </div>
              <p>
                We use cookies for{' '}
                <b className="text-white">
                  website performance, analytics, and security.
                </b>{' '}
                Users can{' '}
                <b className="text-white">
                  disable cookies in their browser settings,
                </b>{' '}
                but some features may not function properly.
              </p>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  8. International Data Transfers
                </h4>
              </div>
              <p>
                If you access our services outside the{' '}
                <b className="text-white">United States</b> your data may be
                transferred to servers in the U.S.{' '}
                <b className="text-white">
                  By using our Website, you consent to this transfer.
                </b>
              </p>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">
                  9. Updates to This Privacy Policy
                </h4>
              </div>
              <p>
                We may update this Privacy Policy periodically. The latest
                version will always be posted on our Website.{' '}
                <b className="text-white">
                  Your continued use of the Website constitutes acceptance of
                  any changes.
                </b>
              </p>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="heading mb-4">
                <h4 className="text-white fw-normal mb-0">10. Contact Us</h4>
              </div>
              <p>
                📩 If you have questions about this Privacy Policy, contact us
                at <a href="mailto:info@unitronix.ai">info@unitronix.ai</a>
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};
export default PrivacyPolicy;
